import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { Observable, map } from 'rxjs';

@Component({
  selector: 'app-auth-dropdown',
  standalone: false,
  templateUrl: './auth-dropdown.component.html',
  styleUrls: ['./auth-dropdown.component.scss']
})
export class AuthDropdownComponent implements OnInit, OnDestroy {
  @Input() isOpen = false;
  @Output() close = new EventEmitter<void>();

  private clickListener?: (event: MouseEvent) => void;
  
  // Authentication state
  isAuthenticated$: Observable<boolean>;
  currentUser$: Observable<any>;

  constructor(
    private router: Router, 
    private elementRef: ElementRef,
    private authService: AuthService
  ) {
    this.isAuthenticated$ = this.authService.currentUser$.pipe(
      map(user => !!user)
    );
    this.currentUser$ = this.authService.currentUser$;
  }

  ngOnInit(): void {
    // Add click listener to document when component initializes
    this.clickListener = this.onDocumentClick.bind(this);
    document.addEventListener('click', this.clickListener);
  }

  ngOnDestroy(): void {
    // Clean up the event listener
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener);
    }
  }

  onDocumentClick(event: MouseEvent): void {
    // Check if the dropdown is open and if the click is outside the dropdown
    if (this.isOpen && !this.elementRef.nativeElement.contains(event.target)) {
      this.close.emit();
    }
  }

  navigateToLogin(): void {
    this.router.navigate(['/auth/login']);
    this.close.emit();
  }

  navigateToRegister(): void {
    this.router.navigate(['/auth/register-multi']);
    this.close.emit();
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
    this.close.emit();
  }

  navigateToOrders(): void {
    this.router.navigate(['/profile'], { queryParams: { section: 'orders' } });
    this.close.emit();
  }

  logout(): void {
    this.authService.logout();
    this.close.emit();
  }

  onBackdropClick(): void {
    this.close.emit();
  }

  getFullName(): string {
    const user = this.authService.getCurrentUser();
    if (!user) return '';
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();
    return fullName || user.email || 'User';
  }

  getInitials(): string {
    const user = this.authService.getCurrentUser();
    if (!user) return 'U';
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    
    if (firstName && lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    } else if (firstName) {
      return firstName.charAt(0).toUpperCase();
    } else if (lastName) {
      return lastName.charAt(0).toUpperCase();
    } else if (user.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U';
  }
}
